export const getYoutubeThumbnail = (url: string, quality = 'high') => {
  if (url) {
    let videoId;
    let result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
    if (result) {
      videoId = result.pop();
    }
    result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/);
    if (!videoId && result) {
      videoId = result.pop();
    }

    if (videoId) {
      let qualityKey = 'hqdefault';
      if (quality === 'low') {
        qualityKey = 'sddefault';
      } else if (quality === 'medium') {
        qualityKey = 'mqdefault';
      }

      return `http://img.youtube.com/vi/${videoId}/${qualityKey}.jpg`;
    }
  }
  return null;
};
